import React from 'react';
import NnPianoKeyboard from './keyboard/NnPianoKeyboard';
import NnSongPanel from './songpanel/NnSongPanel';
import NnSounds from './music/NnSounds';
import Song from './music/Song';
import SongManager from './music/SongManager';
import ScoreTracker from './songpanel/ScoreTracker';
import Tracking from './Tracking';


//---------------- Skins -----------------\\
import './NnPianoApp.css';
import './assets/skins/Tech/style.scss';
import './assets/skins/CandyLand/style.scss';
import './assets/skins/IrishPub/style.scss';
import './assets/skins/classic/style.scss';
import './assets/skins/Christmas/style.scss';
import './assets/skins/valentines/style.scss';

//---------------- Animations -----------------\\
import Animation from "./songpanel/Animation.js";
import './assets/animation/Animations.scss';

class NnPianoApp extends React.Component {
  constructor(props) {
    super(props);

    this.scoreTracker = new ScoreTracker();
  
    this.state = {
      nextNote: null,
      note: null,
      octave: '5',
      scorePercentage: this.scoreTracker.getPercentage(),
      skin: props.skin,
      songId: props.songId,
      songs: props.songs || {},
      title: 'unknown',
    };

    // workaround EC6 unbound methods
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleOctavePress = this.handleOctavePress.bind(this);
    this.loadSong = this.loadSong.bind(this);
    this.playSong = this.playSong.bind(this);
    this.rewindSong = this.rewindSong.bind(this);
    this.setPosition = this.setPosition.bind(this);
    this.setSong = this.setSong.bind(this);
  }

  /* The app window is divided vertically into 3 panels: MenuPanel, SongPanel, and KeyboardPanel
   */
  render() {
    const { timing, letters } = this.props;

    return (
      <div className={['piano-app', `${this.props.skin}-skin`].join(' ')}>
        <NnSongPanel
          id="song-panel"
          cover={this.state.cover}
          timing={timing}
          letters={letters}
          onPlayNote={this.hiliteNote}
          onPlaySong={this.playSong}
          position={this.state.position}
          rewind={this.rewindSong}
          scorePercentage={this.state.scorePercentage}
          skin={this.state.skin}
          song={this.state.song}
          songs={this.state.songs}
          title={this.state.title}
        />
        <NnPianoKeyboard
          letters={letters}
          nextNote={this.state.nextNote}
          note={this.state.note}
          octave={this.state.octave}
          onKeyPress={this.handleKeyPress}
          onOctavePress={this.handleOctavePress}
        />
        <NnSounds />
      </div>
    );
  }

  componentDidUpdate(prevProps) {
    // this happens only once, when the songs index is loaded. -- correnction it happens each time something changes such as song or skin.
    // TODO: I'm sure there is a better way that uses more props and less state
    if (
      this.props.songId !== prevProps.songId ||
      this.props.songs !== prevProps.songs  
    ) {
      this.setState(
        {
          songId: this.props.songId,
          songs: this.props.songs,
        },
        () => {
          this.loadSong(this.props.songId);
          this.startBlink();
        }
      ); 
    }
    if (this.props.skin !== prevProps.skin) { // updates animations when the skin changes
      this.setState(
        {
          skin: this.props.skin,
        },
        () => {
          clearInterval(this.timer);
          clearInterval(this.timerOne);
          this.loadSong(this.props.songId);
          this.loadAnimations();
          this.startBlink();
        }
      ); 
    }
  }

  // will run once on the first load of this component, starts animations
  componentDidMount() {
    this.loadAnimations();
  }

  
  // this takes a filepath and loads a song from it, making it the currentSong
  loadSong(songId) {
    console.log(`Loading song ${songId}: `, SongManager.getSongInfo(songId));
    let song = new Song(SongManager.getSongInfo(songId), this.scoreTracker);
    song
      .readFromCsvFile(song.filename)
      .then(this.setSong)
      .catch(error => console.log(`Problem loading song ${songId}: ${error}`));
    this.scoreTracker.reset(0);
  }

  setSong(song) {
    this.scoreTracker.reset(song.notes.length);
    this.setState(
      {
        cover: song.coverImageUrl,
        nextNote: song.nextNote().name,
        note: song.currentNote(),
        octave: song.currentNote().octave,
        position: 0,
        song: song,
        styleUrl: song.styleUrl,
        title: song.title,
        scorePercentage: this.scoreTracker.getPercentage(),
      },
      () => {
        // record a page view for Google Analytics
        Tracking.pageview(this.state.skin, this.state.songId, this.props.letters, this.props.timing);
      }
    );
  }

  setPosition(index) {
    this.setState({
      position: index,
      note: this.state.song.currentNote(),
      nextNote: this.state.song.nextNote().name,
      octave: this.state.song.currentNote().octave,
    });
  }

  // play straight through the song
  playSong() {
    this.state.song && this.state.song.playWav();
  }

  rewindSong() {
    this.state.song.rewind();
    this.setState({
      position: 0,
      nextNote: this.state.song.nextNote().name,
      note: this.state.song.currentNote(),
      octave: this.state.song.currentNote().octave,
      scorePercentage: this.scoreTracker.getPercentage(),
    });
  }

  hiliteNote() {
    this.setPosition(this.state.song.currentPosition);
  }

  // if the key pressed is the next song note then advance the song
  handleKeyPress(note, octave) {
    if (this.state.song && this.state.song.isAtStart()) {
      this.scoreTracker.reset(this.state.song.notes.length);
    }
    let songNote = this.state.song.currentNote();
    while (songNote.isRest || songNote.isTied) {
      songNote = this.state.song.advance();
    }

    // Tracking.event('key_press', 'Piano', 'Pressed Key', note + octave);

    if (note === songNote.name && octave === songNote.octave) {
      this.stopBlink();
      this.blinkOnce();
      songNote = this.state.song.advance();
      while (songNote.isRest) {
        songNote = this.state.song.advance();
      }
      this.setPosition(this.state.song.currentPosition);
      this.scoreTracker.keyPressed(true);
      if (this.state.song.isAtStart()) {
        let score = this.scoreTracker.getPercentage();
        // signal score to analytics
        Tracking.score(score, this.state.skin, this.state.songId, this.props.letters, this.props.timing);
      }
    } else {
      this.scoreTracker.keyPressed(false);
    }
    this.setState({
      scorePercentage: this.scoreTracker.getPercentage(),
    });
  }

  handleOctavePress(octave) {
    this.setState({
      octave: octave,
    });
  }

  stopBlink() {
    let elem = document.getElementsByClassName("blink");
      for (let i = 0; i < elem.length; i++) {
        elem[i].style.animation = "none";
      }
  }

  startBlink() {
    let elem = document.getElementsByClassName("blink");

    for (let i = 0; i < elem.length; i++) {
      elem[i].style.animation = "indicator 1s infinite";
    }
  }

  blinkOnce() {
    let elem = document.getElementsByClassName("blink")

    window.requestAnimationFrame(function() {
      for (let i = 0; i < elem.length; i++) {
        elem[i].style.animation = "blink .6s";
      }
    })
  }

  loadAnimations() {
    this.AnimationOne = new Animation("sprite", -50, 96, .3);
    this.AnimationTwo = new Animation("sprite2", 65, 75, .3, true);

    if(this.props.skin === "candyland") {   
    }
    if(this.props.skin === "irishpub") { 
      this.timer = this.AnimationOne.animateBacknForth(15, 25, .1, true);
      this.timerOne = this.AnimationTwo.animateBacknForth(55, 70, .1, true);
    }
    if(this.props.skin === "christmas") {
    }
    if(this.props.skin === "tech") {
    }
  }
}
export default NnPianoApp;
